/* eslint-disable max-lines-per-function */
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import React from 'react';
import { Center } from 'native-base';
import { useAppSettings, useProfileInterests, useSpringBigStore } from '@springbig/shared';

import Section from '~/shared/Section';
import ProfileHeader, { ProfileHeaderSkeleton } from './components/ProfileHeader';
import ProfileInterest from './components/ProfileInterest';
import { useAuthorization } from '~/hooks/auth';
import { useLocation } from 'react-router';

const ProfileScreen = () => {

    const { state } = useLocation();

    const {
        interest,
        updateIsLoading,
        memberIsLoading,
        handleInterest
    } = useProfileInterests();

    const { member } = useSpringBigStore();

    const { isLoadingAuth } = useAuthorization();
    const { profile } = useAppSettings();

    return (
        <Section flex={1} w={'100%'} h={'100%'} overflowY={'auto'} overflowX={'hidden'}>
            <Center alignItems={'center'} position={'relative'}>
                {((!(state && state.isInterestScreen) && memberIsLoading) || isLoadingAuth) ? <ProfileHeaderSkeleton /> : <ProfileHeader member={member} />}
                {
                    !profile?.hideInterests && interest && interest?.length > 0 && <ProfileInterest
                        handleInterest={handleInterest}
                        interest={interest}
                        updateIsLoading={updateIsLoading}
                    />
                }
            </Center>
        </Section>
    );
};

export default ProfileScreen;
